import React from "react";
import MagicLoader from "./MagicLoader";

// Full-screen loading overlay. Kept as a thin wrapper so every existing call site
// (`<LoadingOverlay isLoading={...} />`) keeps working while the visual is the magic loader.
const LoadingOverlay: React.FC<{ isLoading: boolean }> = ({ isLoading }) => (
  <MagicLoader isLoading={isLoading} variant="overlay" />
);

export default LoadingOverlay;
